var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.8 18",
    style: {
      enableBackground: "new 0 0 18.8 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1AB394;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1575_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1576_",
    className: "st0",
    d: "M15.5,0H3.3C1.5,0,0,1.5,0,3.3v7.5c0,1.8,1.5,3.3,3.3,3.3l7.8,0l3.7,3.7 c0.1,0.1,0.3,0.2,0.5,0.2c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.4-0.3,0.4-0.6v-3.3c1.6-0.2,2.9-1.6,2.9-3.3V3.3C18.8,1.5,17.3,0,15.5,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.cd5cb6e5e5e9eca452217321f83df8a7.svg";
export { ForwardRef as ReactComponent };